var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('NewsPage', {
    attrs: {
      "newsHeaderTitle": _vm.newsHeaderTitle,
      "newsItems": _vm.newsItems,
      "isRecentNews": true
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }